module.exports = __webpack_public_path__ + "static/kokoomus-logo-cc24fbf4675a21ca4103ef5190a36056.svg";